module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcpDashboard"
    }
  }, [(_vm.isHcpVerified) ? _c('hcp-getting-started-modal') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("Low Carb Program: Healthcare Professional Platform")]), _vm._v(" "), _c('mu-card', {
    staticClass: "downloads"
  }, [_c('div', {
    staticClass: "mu-card-title-container"
  }, [_c('div', {
    staticClass: "mu-card-title"
  }, [_vm._v("\n          Core Resources\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "mu-card-sub-title"
  }, [_vm._v("\n          Key information and guidance to support your patients\n        ")])]), _vm._v(" "), _c('mu-card-text', [_c('ul', [_vm._l((_vm.downloads.modules), function(download, downloadIndex) {
    return (!_vm.downloads.isLoading) ? _c('li', {
      key: ("download-" + downloadIndex)
    }, [_c('a', {
      attrs: {
        "href": download.link,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("\n              " + _vm._s(download.title) + "\n              "), _c('mu-icon', {
      attrs: {
        "value": "open_in_new",
        "size": 16,
        "color": "#A8A8A8"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), _vm._l((5), function(download, downloadIndex) {
    return (_vm.downloads.isLoading) ? _c('li', {
      key: ("download-" + downloadIndex),
      staticStyle: {
        "margin": "15px 0 0"
      }
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "20px",
        "width": "10%",
        "background": "#f1f1f1"
      },
      style: ({
        width: _vm.getRandomArbitrary(15, 25)
      }),
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  })], 2)])], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "commission"
  }, [_c('mu-card-title', {
    attrs: {
      "title": "Learn more about commissioning the program"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-flat-button', {
    attrs: {
      "label": "Contact Us",
      "backgroundColor": "#FFF",
      "color": "#0179d5"
    },
    on: {
      "click": _vm.goToFeedbackCommission
    }
  })], 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "modules"
  }, [_c('mu-card-title', {
    attrs: {
      "title": "Professional Development"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "60",
      "tablet": "6",
      "width": "100"
    }
  }, [_c('mu-list', {
    staticClass: "links"
  }, _vm._l((_vm.quickLinks), function(link, index) {
    return _c('div', {
      key: ("link-" + index),
      staticClass: "linkWrap"
    }, [_c('mu-list-item', {
      attrs: {
        "title": link.label
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goTo(link.to, link.type)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_c('mu-icon', {
      attrs: {
        "value": link.icon,
        "color": "#0179d5"
      }
    })], 1)]), _vm._v(" "), _c('mu-divider')], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "recent"
  }, [_c('h3', {
    staticClass: "largeTitle blueTitle"
  }, [_vm._v("Recently added")]), _vm._v(" "), _c('mu-list', [_vm._l((_vm.recent.modules), function(post, index) {
    return (!_vm.recent.isLoading) ? _c('mu-list-item', {
      key: ("post-" + index),
      staticClass: "item",
      attrs: {
        "title": post.post_title,
        "describeText": post.post_excerpt,
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToModule(post.post_slug)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "src": post.post_video_thumb
      }
    })], 1), _vm._v(" "), _c('mu-divider')], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((3), function(post, index) {
    return (_vm.recent.isLoading) ? _c('mu-list-item', {
      key: ("post-" + index)
    }, [_c('div', {
      attrs: {
        "slot": "leftAvatar"
      },
      slot: "leftAvatar"
    }, [_c('mu-avatar', {
      attrs: {
        "size": 40,
        "backgroundColor": "#F1F1F1"
      }
    })], 1), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "height": "13px",
        "width": "10%",
        "background": "#f1f1f1",
        "position": "relative",
        "top": "-5px"
      },
      style: ({
        width: _vm.getRandomArbitrary(40, 60)
      }),
      attrs: {
        "slot": "title",
        "color": "#d9d9d9"
      },
      slot: "title"
    }), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "height": "13px",
        "width": "10%",
        "background": "#f1f1f1"
      },
      style: ({
        width: _vm.getRandomArbitrary(80, 100)
      }),
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "block-rcgp",
    staticStyle: {
      "background-image": "url('static/hcp/rcgp-module.jpg')"
    },
    attrs: {
      "desktop": "40",
      "tablet": "40",
      "width": "100"
    }
  }, [_c('img', {
    staticClass: "rcgp-bg",
    attrs: {
      "src": "static/hcp/rcgp-module.jpg",
      "alt": "RCGP"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rcgp-module"
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('img', {
    staticClass: "rcgp-logo",
    attrs: {
      "src": "static/hcp/rcgp.png",
      "alt": "RCGP logo"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.quickLinks[1].label))]), _vm._v(" "), _c('p', [_vm._v("Written by Dr David Unwin, this module describes the use of a low GI diet as an adjunct treatment for diabetes, using a case study of a real patient registered at the author's practice. The physiology and evidence behind a low glycaemic-index diet are described, as well as how to implement it in real life.")]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "view",
    attrs: {
      "label": "View Module",
      "icon": "play_circle_filled",
      "color": "#FFF",
      "href": _vm.quickLinks[1].to,
      "target": "_blank"
    }
  })], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('mu-flexbox', {
    staticClass: "information",
    attrs: {
      "align": "stretch"
    }
  }, [_c('mu-flexbox-item', [_c('mu-row', {
    attrs: {
      "gutter": true
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('mu-card', [_c('mu-card-title', {
    attrs: {
      "title": "Resources"
    }
  }), _vm._v(" "), _c('mu-card-text', [_vm._l((_vm.cats.data), function(cat, index) {
    return (!_vm.cats.isLoading) ? _c('md-chip', {
      key: ("cat-" + index),
      staticClass: "cat",
      domProps: {
        "textContent": _vm._s(cat.name)
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goToResourceCat(cat.slug)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((5), function(cat, index) {
    return (_vm.cats.isLoading) ? _c('mu-linear-progress', {
      key: ("cat-" + index),
      staticClass: "cat",
      staticStyle: {
        "display": "inline-block",
        "height": "32px",
        "width": "10%",
        "background": "#f1f1f1"
      },
      style: ({
        width: _vm.getRandomArbitrary(10, 20)
      }),
      attrs: {
        "color": "#d9d9d9"
      }
    }) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('mu-col', {
    staticClass: "feedback",
    staticStyle: {
      "background-image": "url('static/hcp/hcp-feedback.jpg')"
    },
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('div', {
    staticClass: "desc"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Contact us")]), _vm._v(" "), _c('p', [_vm._v("Contact us to discuss your needs, queries and suggestions for development of the platform")]), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "action",
    attrs: {
      "label": "Contact us",
      "icon": "play_circle_filled",
      "color": "#FFF"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goToFeedback()
      }
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('mu-card', {
    staticClass: "forum"
  }, [_c('mu-card-title', {
    attrs: {
      "title": "Latest from the forum"
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('hcp-forum', {
    attrs: {
      "amount": 5
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8d2be7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/HCP.vue
// module id = 3187
// module chunks = 1